<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import EventActionRelationFilter from "../../filterImplementations/EventActionRelationFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<EventActionRelationFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() => {
  return props.filter.filters
    .map((filter) =>
      t(`components.event-action.filter.ui.badges.EventActionRelationFilterBadge.${filter}`),
    )
    .join(", ");
});
</script>

<style lang="scss" scoped></style>
